module.exports = __webpack_public_path__ + "img/playing.f5a751dd.gif";